import React from 'react';
import { View } from 'react-native';

interface ITabItemProps {
  label: string;
  sublabel?: string;
  count?: number;
  children: React.ReactNode;
}

export const TabItem = ({ children }: ITabItemProps) => {
  return <View>{children}</View>;
};
